module.exports = __webpack_public_path__ + "img/good_61.f85af09e.png";